var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfopaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #99cfe2;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #121628;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70,140C31.53,140,0,108.47,0,70S31.53,0,70,0s70,31.53,70,70-31.53,70-70,70ZM70,3.78C33.42,3.78,4.41,33.42,4.41,69.37s29.64,65.59,65.59,65.59,65.59-29.64,65.59-65.59S105.95,3.78,70,3.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.72,
    y: 46.88,
    width: 40.79,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.72,
    y: 56.51,
    width: 21.8,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.7,116.87c-7.84,0-14.23-6.38-14.23-14.23s6.38-14.23,14.23-14.23,14.23,6.38,14.23,14.23-6.38,14.23-14.23,14.23ZM99.7,90.42c-6.74,0-12.23,5.48-12.23,12.23s5.48,12.23,12.23,12.23,12.23-5.48,12.23-12.23-5.48-12.23-12.23-12.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.73,108.66h-47.56V31.34h63.66v56.41l-.58-.1c-.89-.15-1.69-.22-2.47-.22-8.06,0-14.62,6.56-14.62,14.62,0,2.04.42,4.03,1.25,5.91l.31.7ZM39.17,107.66h45.04c-.7-1.8-1.05-3.68-1.05-5.61,0-8.61,7.01-15.62,15.62-15.62.66,0,1.33.05,2.05.15v-54.23h-61.66v75.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.11,102.12c0-1.54-.05-1.57-1.47-1.74v-.86c1.52-.2,3.56-.56,5.44-.91v8.93c0,1.44.13,1.57,1.47,1.72v.99h-6.9v-.99c1.34-.15,1.47-.28,1.47-1.72v-5.41ZM102.23,95.19c0,1.21-.96,2.2-2.2,2.2s-2.2-.99-2.2-2.2,1.01-2.2,2.2-2.2,2.2.96,2.2,2.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfopaper);
export default __webpack_public_path__ + "static/media/infopaper.c452e04fda10b9d14d2f8ee78af57f45.svg";
export { ForwardRef as ReactComponent };